var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserX = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 20,
  viewBox: "0 0 22 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 19c0-1.323-.011-2.206.215-2.951a5.002 5.002 0 0 1 3.334-3.334c.745-.226 1.629-.215 2.951-.215H11a1 1 0 1 1 0 2H6.5c-1.468 0-1.98.01-2.371.129a3 3 0 0 0-2 2C2.011 17.019 2 17.532 2 19a1 1 0 1 1-2 0Zm19.793-5.707a1 1 0 1 1 1.414 1.414L19.414 16.5l1.793 1.793a1 1 0 1 1-1.414 1.414L18 17.914l-1.793 1.793a1 1 0 1 1-1.414-1.414l1.793-1.793-1.793-1.793a1 1 0 1 1 1.414-1.414L18 15.086l1.793-1.793ZM12.5 5.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0Zm2 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z",
  fill: "currentColor"
})));
SvgUserX.displayName = "SvgUserX";
export { SvgUserX as ReactComponent };
export default SvgUserX;